import React from 'react';
import { Breadcrumbs, Typography, Link, LinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

const LinkRouter = (props: LinkRouterProps) => <Link {...props} component={RouterLink as any} underline="hover" />;

function generateLinks(nameMap: Record<string, string>) {
    var returnValue = [];
    for (const key in nameMap) {
        returnValue.push(<LinkRouter color="inherit" to={nameMap[key]} key={key}>{key}</LinkRouter>);
    }
    return returnValue;
}

interface OntimeBreadcrumProps {
    nameMap: Record<string, string>;
    current: string;
}

function OntimeBreadcrumb(props: OntimeBreadcrumProps) {
    const { t } = useTranslation("common");
    const { nameMap, current } = props;
    return (
        <Breadcrumbs aria-label="breadcrumb">
            <LinkRouter color="inherit" to="/">
                {t("home")}
            </LinkRouter>
            {generateLinks(nameMap)}
            <Typography color="textPrimary" key={current}>
                {current}
            </Typography>

        </Breadcrumbs>
    );
}

export default OntimeBreadcrumb;